<template>
  <div class="property_wrap">
    <div class="pro_top">标题栏设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="100px">
        <el-form-item label="产品图编辑:">
          <div style="overflow: hidden;">
            <draggable v-model="form.pic" :options="{draggable:'.draggableItem',animation: 150}" :move="getdata"
                       @update="datadragEnd" class="draggable-body-list">
              <transition-group class="draggable-body">
                <div v-for="(item,index) in form.pic" :key="item" class="draggableItem" :draggable="draggable"
                     :style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"
                  :class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">
                  <i class="el-icon-circle-close" @click="detelFn(index)"></i>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div>
            <div class="img_body" @click="showCropper">
              <p class="img_up_text">点击上传</p>
            </div>
            <p class="prompInfo">第一张默认为封面,可以拖拽图片调整顺序，最多上传5张，尺寸702*960比例，大小在2M以内</p>
            <!--end-->
          </div>
        </el-form-item>
      </el-form>

    </div>
    <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>
  </div>
</template>
<script>
  import api from "@/api.js"
  import uploadImg from "@/components/dialog/uploadImg.vue";
  import corpper from "@/components/dialog/corpper.vue";
  import draggable from 'vuedraggable';

  export default {
    props: ["property"],
    components: {
      uploadImg,
      corpper,
      draggable
    },
    data() {
      return {
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        form: {
          pic: []
        },
        imgSize: 9,
        corppervisible: false,
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    created() {
      if (this.property.pic.length !== 0) {
        let fileList = []
        for (let i in this.property.pic) {
          let fileList_line = {};
          fileList_line.name = i;
          fileList_line.url = this.property.pic[i];
          fileList.push(fileList_line)
        }
        this.fileList = fileList
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      handleRemove(file, fileList) {
        let pic = []
        for (let i in  fileList) {
          pic.push(fileList[i].response.path)
        }
        this.form.pic = pic
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleSuccess(response, file, fileList) {
        if (response.code === 0) {
          let pic = []
          for (let i in  fileList) {
            pic.push(fileList[i].response.path)
          }
          this.form.pic = pic
        }
        this.loadingStatus.close();
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 1MB!');
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
        return isLt2M;
      },
      getChildValue(option) {
        this.form.pic = option
      },
      showCropper() {
        this.corppervisible = true
      },
      imgAddBack(option) {
        this.form.pic.push(option)
      },
      datadragEnd(evt) {
        this.currentindex = evt.newIndex
      },
      detelFn(index) {
        this.form.pic.splice(index, 1)
      },
    }
  };
</script>

